import React from 'react';

const Delivery: React.FC = () => {
    return <h1>Delivery</h1>;
};

export default Delivery;
